<template>
    <div>
        <div class="container max-w-3xl px-6 pt-6 pb-12 mx-auto md:px-12">
            <div class="max-w-md mx-auto text-center">
                <h1 class="mb-6 text-4xl font-semibold leading-tight tracking-tight font-noto-sans lg:text-6xl text-grey-darkest">
                    See <span class="text-blue">Rentora</span> in action
                </h1>

                <h2 class="text-xl lg:text-2xl">
                    You could save yourself a bunch of money, and a lot of hassle in the next 6 minutes.
                </h2>

                <div class="mt-12 mb-2 text-grey-darker">
                    Watch the demo ⬇
                </div>
            </div>

            <div class="p-3 bg-white rounded shadow-lg md:p-6">
                <div class="relative aspect-ratio-16/9">
                    <youtube-player
                        class="absolute inset-0"
                        video-id="EvBIfeyTCNk"
                        player-width="100%"
                        player-height="100%"
                        :player-vars="{
                            autoplay: 0,
                            showinfo: 0,
                            controls: 0,
                            autohide: 1
                        }"
                    />
                </div>
            </div>

            <div class="mt-6 mb-12">
                <a
                    href="https://www.youtube.com/watch?v=EvBIfeyTCNk"
                    class="inline-flex items-center no-underline text-blue"
                >
                    Watch on YouTube

                    <base-svg
                        name="icon-cheveron-right"
                        class="w-5 h-5 fill-primary-blue"
                    />
                </a>
            </div>

            <div class="flex flex-col items-center max-w-xl p-3 mx-auto rounded lg:flex-row bg-blue-bg-dark xs:p-6 lg:p-12">
                <div class="mb-6 lg:mb-0 lg:w-1/2">
                    <h6 class="text-2xl font-semibold md:text-3xl font-noto-sans text-blue-darkest">
                        Ready to get started?
                    </h6>

                    <p class="text-lg lg:text-xl">
                        Create an account in a couple of minutes
                    </p>
                </div>

                <div class="flex flex-col justify-center w-full lg:w-1/2 md:flex-row lg:justify-end">
                    <laroute-link
                        :to="{
                            name: 'auth.users.create'
                        }"
                        class="w-full mb-3 shadow-md md:mb-0 md:mr-3 md:w-auto btn btn-blue-darkest btn-xl"
                    >
                        Get started
                    </laroute-link>

                    <callback-requests-create-button
                        class="w-full shadow-md md:w-auto btn btn-white btn-xl"
                    >
                        Request a callback
                    </callback-requests-create-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HeadMixin from '../../../mixins/head'

    export default {
        mixins: [
            HeadMixin
        ],
        methods: {
            head () {
                return {
                    title: [
                        'See Rentora in action',
                        'Watch the demo'
                    ]
                }
            }
        }
    }
</script>
